<template>
  <nav class="top-nav container-fluid">
    <div class="nav-container">
      <div class="nav-brand">Inpatient Dashboard</div>
      <ul class="nav-links">
        <!-- <li>
          <a
            href="/inpatient/awaiting_bed_assignment"
            :class="{
              active: currentPath === '/inpatient/awaiting_bed_assignment',
            }"
          >
            Awaiting Bed Assignment
          </a>
        </li> -->
        <li style="position: relative">
          <a
            href="/inpatient/awaiting_bed_assignment"
            :class="{
              active: currentPath === '/inpatient/awaiting_bed_assignment',
            }"
            style="position: relative; display: inline-block"
          >
            Awaiting Bed Assignment
            <span
              v-if="awainting_beds_count > 0"
              style="
                position: absolute;
                top: -6px;
                right: -12px;
                background: red;
                color: white;
                font-size: 20px;
                font-weight: bold;
                padding: 2px 6px;
                border-radius: 50%;
                line-height: 1;
              "
            >
              {{ awainting_beds_count }}
            </span>
          </a>
        </li>

        <li>
          <a
            href="/inpatient/inpatient_list"
            :class="{ active: currentPath === '/inpatient/inpatient_list' }"
          >
            Hospitalized Inpatients
          </a>
        </li>
        <li>
          <a
            href="/inpatient/icu"
            :class="{ active: currentPath === '/inpatient/icu' }"
          >
            ICU
          </a>
        </li>
        <li>
          <a
            href="/inpatient/hdu"
            :class="{ active: currentPath === '/inpatient/hdu' }"
          >
            HDU
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
export default {
  name: "InpatientNav",
  data() {
    return {
      currentPath: window.location.pathname,
      awainting_beds_count: 0,
    };
  },
  methods: {
    async get_waiting_count() {
      const response = await generalApiRequest(
        "awaiting_beds_counter",
        "GET",
        {},
        1
      );

      this.awainting_beds_count = response.data;
    },
  },
  mounted() {
    this.get_waiting_count();
  },
};
</script>

<style scoped>
.top-nav {
  background: #ffffff;
  border-bottom: 2px solid #e5e7eb;
  padding: 0.8rem 1.5rem;
  margin-top: 1rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-brand {
  font-weight: 700;
  font-size: 1.2rem;
  color: #16a34a;
}

.nav-links {
  list-style: none;
  display: flex;
  gap: 1.5rem;
  margin: 0;
  padding: 0;
}

.nav-links a {
  text-decoration: none;
  font-weight: 500;
  color: #374151;
  padding: 6px 10px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.nav-links a:hover {
  background: #16a34a;
  color: #ffffff;
}

.nav-links a.active {
  background: #2e8a50;
  color: #ffffff;
  font-weight: 600;
}
</style>
